const headers = {
  name: "Voucher",
  navigate: {
    path: [
      {
        name: "Voucher",
        path: "/app/purchases/voucher",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
